/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardDiscoverLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 20"
    {...props}
  >
    <path
      fill="#231F20"
      d="M5.08 8.119H4v3.774h1.078c.57 0 .986-.134 1.35-.436.43-.357.686-.893.686-1.448 0-1.113-.833-1.89-2.03-1.89H5.08Zm.862 2.835c-.232.207-.531.299-1.008.299h-.198V8.756h.198c.477 0 .767.085 1.008.305.256.225.409.579.409.939s-.153.725-.41.951v.003ZM8.185 8.119H7.45v3.774h.735V8.119ZM9.99 9.567c-.443-.164-.571-.271-.571-.475 0-.238.232-.418.55-.418.22 0 .402.091.595.305l.385-.503a1.653 1.653 0 0 0-1.112-.418c-.668 0-1.178.464-1.178 1.082 0 .522.238.787.93 1.034.288.1.438.17.51.213a.45.45 0 0 1 .22.39c0 .306-.244.534-.573.534-.351 0-.635-.177-.806-.503l-.477.457c.34.497.748.72 1.31.72.767 0 1.304-.51 1.304-1.238 0-.6-.248-.872-1.087-1.177v-.003ZM11.31 10.01c0 1.109.872 1.969 1.993 1.969.317 0 .589-.061.925-.22v-.866c-.296.296-.556.415-.892.415-.742 0-1.27-.537-1.27-1.302 0-.725.544-1.296 1.237-1.296.35 0 .616.125.925.424v-.866a1.875 1.875 0 0 0-.907-.231c-1.117 0-2.012.878-2.012 1.975v-.003ZM20.075 10.652l-1.01-2.533h-.804l1.603 3.869h.397l1.633-3.87h-.8l-1.02 2.534ZM22.227 11.893h2.09v-.64h-1.355v-1.018h1.304v-.64h-1.304v-.836h1.356v-.64h-2.091v3.774ZM27.237 9.231c0-.707-.489-1.112-1.337-1.112h-1.093v3.774h.735v-1.515h.098l1.02 1.515h.907l-1.191-1.591c.556-.113.86-.491.86-1.07Zm-1.48.625h-.218V8.713h.226c.458 0 .709.192.709.561 0 .369-.25.582-.72.582h.002ZM27.823 8.317c0-.067-.046-.104-.125-.104h-.107v.333h.08v-.128l.094.128h.098l-.11-.137c.045-.012.073-.046.073-.092h-.003Zm-.14.046h-.013v-.089h.015c.04 0 .062.016.062.043 0 .028-.022.046-.061.046h-.004Z"
    />
    <path
      fill="#231F20"
      d="M27.713 8.088a.29.29 0 1 0 0 .58.29.29 0 0 0 .287-.29.29.29 0 0 0-.287-.29Zm0 .532a.235.235 0 0 1-.232-.239c0-.13.104-.238.232-.238s.229.11.229.238a.237.237 0 0 1-.23.239Z"
    />
    <path
      fill="#F47922"
      d="M18.469 10a2 2 0 0 1-2.003 2 1.999 1.999 0 0 1-2.003-2c0-1.107.894-2 2.003-2 1.108 0 2.002.893 2.002 2Z"
    />
  </svg>
);

export default SvgCardDiscoverLogo;
